import React, { useState } from "react";
import PropTypes from "prop-types";
import "./ContactForm.css";
import { Grid, Button, TextField, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

function ContactForm({ onClose }) {
  const [formData, setFormData] = useState({
    fullName: "",
    companyName: "",
    emailAddress: "",
    phoneNumber: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

 
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const phoneRegex = /^\d{7,15}$/;

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = "Please enter your name.";
    if (!formData.companyName.trim()) newErrors.companyName = "Please enter your company name.";

    if (!formData.emailAddress.trim()) {
      newErrors.emailAddress = "Please enter your email.";
    } else if (!emailRegex.exec(formData.emailAddress)) {
     
      newErrors.emailAddress = "Please enter a valid email format.";
    }

    if (!phoneRegex.exec(formData.phoneNumber || "")) {
      newErrors.phoneNumber = "Enter valid 7-15 digit contact number.";
    }

    if (!formData.message.trim()) newErrors.message = "Please write something in requirement.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const response = await fetch(
        "https://www.paytechadvisors.com/admin/api/FormSubmissionApi/ContactUs",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
   

        setFormData({
          fullName: "",
          companyName: "",
          emailAddress: "",
          phoneNumber: "",
          message: "",
        });

   
        if (typeof onClose === "function") {
          try {
            onClose();
          } catch (cbErr) {
        
            console.error("onClose callback threw an error:", cbErr);
          }
        }

        navigate("/thankyou");
      } else {
     
        let serverMsg = "Submission failed. Try again!";
       try {
  const json = await response.json();
  if (json?.message) serverMsg = json.message;
} catch {
        
        }
        alert(serverMsg);
      }
    } catch (err) {
     
      console.error("ContactForm submit error:", err);
      alert("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="frm">
      <Grid container spacing={2}>
        <TextField
          fullWidth
          label="Your Name"
          name="fullName"
          value={formData.fullName}
          onChange={handleChange}
          error={!!errors.fullName}
          helperText={errors.fullName}
          disabled={loading}
        />

        <TextField
          fullWidth
          label="Company Name"
          name="companyName"
          value={formData.companyName}
          onChange={handleChange}
          error={!!errors.companyName}
          helperText={errors.companyName}
          disabled={loading}
        />

        <TextField
          fullWidth
          label="Email Address"
          type="text"
          name="emailAddress"
          value={formData.emailAddress}
          onChange={handleChange}
          error={!!errors.emailAddress}
          helperText={errors.emailAddress}
          disabled={loading}
        />

        <TextField
          fullWidth
          label="Contact Number"
          type="tel"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
          error={!!errors.phoneNumber}
          helperText={errors.phoneNumber}
          disabled={loading}
        />

        <TextField
          fullWidth
          label="Requirement"
          multiline
          rows={1}
          name="message"
          value={formData.message}
          onChange={handleChange}
          error={!!errors.message}
          helperText={errors.message}
          disabled={loading}
        />

        <Button
          type="submit"
          fullWidth
          variant="contained"
          className="formBtn"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
        </Button>
      </Grid>
    </form>
  );
}

ContactForm.propTypes = {
  onClose: PropTypes.func,
};

ContactForm.defaultProps = {
  onClose: undefined,
};

export default ContactForm;
